import { Component, Input, OnInit } from '@angular/core';
import { GroupService } from 'src/app/services/group/group.service';
import * as enviroment from '../../../../../../environments/environment';
declare var jQuery: any;

declare function initDropdowns(): any;
declare function initLightboxEmojis(): any;
@Component({
  selector: 'app-group-album',
  templateUrl: './group-album.component.html',
  styleUrls: ['./group-album.component.scss'],
})
export class GroupAlbumComponent implements OnInit {
  @Input() set dataGroup(dataGroup: any) {
    this.dataGroups = dataGroup;
    this.getAlbumGroup(dataGroup._id);
  }

  dataGroups;
  enviroment;
  constructor(private groupService: GroupService) {
    this.enviroment = enviroment.environment.apiUrl;
  }

  ngOnInit(): void {
    this.skip = 0;
    this.limit = 9;
    this.isActiveAlbum = false;
    this.isDelete = false;
  }

  //#region Load icon feather
  loadIconFeather() {}
  //#endregion

  //#region Get album by groupId;
  arrAlbumm = [];
  listShowAblum = [];
  getAlbumGroup(groupId) {
    this.arrAlbumm = [];
    this.arrPhoto = [];
    this.listShowAblum = [];
    this.groupService.getAlbumGroup(groupId).subscribe((result) => {
      if (result.status == 'success') {
        this.listShowAblum = result.data;
      }
    });
  }
  //#endregion

  //#region Get photo of album in group
  skip;
  limit;
  arrPhoto = [];
  listShowPhoto = [];
  albumIdCurrent;
  getPhotoByAlbumId(albumId, skip, limit) {
    this.listShowPhoto = [];
    this.albumIdCurrent = albumId;
    let requestData = {
      albumId: albumId,
      skip: skip,
      limit: limit,
    };

    this.groupService.getPhotoByAlubmId(requestData).subscribe((result) => {
      if (result.status == 'success') {
        this.arrPhoto = this.arrPhoto.concat(result.data);
      }
      this.loadFancybox();
    });
  }
  //#endregion

  //#region Open/Close album
  isActiveAlbum: boolean = false;
  titleAlbum;
  openAlbum(album) {
    this.arrPhoto = [];
    this.titleAlbum = album.albumName;
    this.getPhotoByAlbumId(album._id, this.skip, this.limit);
    this.isActiveAlbum = !this.isActiveAlbum;
  }
  closeAlbum() {
    this.isActiveAlbum = !this.isActiveAlbum;
    this.getAlbumGroup(this.dataGroups._id);
    this.loadIconFeather();
    this.skip = 0;
    this.limit = 5;
  }
  //#endregion

  //#region deleteImg of photo in album
  isDelete: boolean = false;
  photoId;
  openModalDelete(photoId) {
    this.loadIconFeather();
    this.photoId = photoId;
    this.isDelete = !this.isDelete;
  }
  closeModalDelete() {
    this.isDelete = !this.isDelete;
  }
  deleteImg() {
    this.isDelete = false;
    if (this.photoId) {
      this.groupService.deleteAlbum(this.photoId).subscribe((result) => {
        if (result.status == 'success') {
          let indexDetele = this.listShowPhoto.find(
            (index) => index._id === this.photoId
          );
          if (indexDetele) {
            this.listShowPhoto.splice(indexDetele, 1);
          }
        }
      });
    }
  }
  //#endregion

  //#region Load more photo of album
  skipCurrent = 0;
  getMorePhoto() {
    this.skip = this.skipCurrent + 5;
    this.skipCurrent = this.skip;
    this.getPhotoByAlbumId(this.albumIdCurrent, this.skip, this.limit);
    this.loadIconFeather();
  }
  //#endregion

  //#region JQUERY ZOOM IMAGE USING FANCYBOX
  loadFancybox() {
    (function ($) {
      $(document).ready(function () {
        if ($('[data-fancybox]').length) {
          $('[data-fancybox]').each(function () {
            if ($(this).attr('data-lightbox-type') == 'photo') {
              $(this).fancybox({
                baseClass: 'fancybox-custom-layout',
                keyboard: false,
                infobar: false,
                touch: {
                  vertical: false,
                },
                buttons: ['close', 'thumbs', 'share'],
                animationEffect: 'fade',
                transitionEffect: 'fade',
                preventCaptionOverlap: false,
                idleTime: false,
                gutter: 0,
                caption: false,
                afterShow: function (instance, current) {
                  initDropdowns();
                  initLightboxEmojis();
                },
              });
            }
          });
        }
      });
    })(jQuery);
  }
  //#endregion
}
